import React from "react";
import { controlPropTypes } from "../formhelpers";
import GonkBox from "views/GonkBox";

export default class NotFound extends React.PureComponent {

    componentDidMount() {
        const { descriptor } = this.props;
        console.warn(`No '<code>app/lib/common/descriptorcontrols/${descriptor.type}/${descriptor.control}.js</code>' found for '${descriptor.key}'.`);
    }

    render() {
        const {descriptor} = this.props;
        return <GonkBox
            id={descriptor.id}
            data-control-type={descriptor.control}
            data-shortname={descriptor.key}
        >
            No
            '<code>app/lib/common/descriptorcontrols/{descriptor.type}/{descriptor.control}.js</code>'
            found for '{descriptor.key}'.
        </GonkBox>;
    }
}

NotFound.propTypes = controlPropTypes();



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/BaseControls/NotFound.js